import React from 'react'
import {Input, Button} from 'reactstrap'
import {AvForm, AvGroup, AvInput} from 'availity-reactstrap-validation'
import PropTypes from 'prop-types'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'

const ProjectNoteInput = ({note, onChange, onSave, onFormCreated, saving}) => {

    return (
        <AvForm
            ref={ref => {
                if(onFormCreated) onFormCreated(ref)
            }}
            className="d-flex flex-row"
            onValidSubmit={onSave}
        >
            <AvGroup className="mr-1 pb-0 mb-0"
                     style={{flex: 1}}>
                <AvInput
                    name="note"
                    bsSize="sm"
                    required
                    className="form-control-sm"
                    style={{flex: 1}}
                    type="textarea"
                    placeholder="Enter Note"
                    value={note}
                    onChange={(evt) => onChange(evt.target.value)}
                />
            </AvGroup>
            <Button
                size="sm"
                color="success"
                className="ml-2"
                disabled={saving}
            >
                <FontAwesomeIcon
                    color="#fff"
                    icon={saving ? 'spinner' : 'save'}
                />{' '}
                {saving ? 'Saving...' : 'Save'}
            </Button>
        </AvForm>
    )

}

ProjectNoteInput.propTypes = {
    note: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    onFormCreated: PropTypes.func,
    saving: PropTypes.bool
}

export default ProjectNoteInput